// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__c2A_t","footer":"styles_footer__1PSpq","passCodeTooltip":"styles_passCodeTooltip__17Zzt"};